import { DateTime } from 'luxon';
import { useQuery } from 'react-query';
import { buildEndpoint } from '../endpoints';
import { apifetch } from '../robotapi';

interface LateEarlyRetirement {
    created?: string;
    factors?: LateEarlyRetirementFactor[];
}

export interface LateEarlyRetirementFactor {
    targetAge?: number;
    earlyFactor?: number;
    lateFactor?: number;
}

export interface PensionCalcData {
    taxBracketAmount1?: number;
    taxBracketAmount2?: number;
    employedTaxPercentageDisc1?: number;
    employedTaxPercentageDisc2?: number;
    employedTaxPercentageDisc3?: number;
    retiredTaxPercentageDisc1?: number;
    retiredTaxPercentageDisc2?: number;
    retiredTaxPercentageDisc3?: number;
    nationalInsurancePremiumPercentage?: number;
    retiredNationalInsurancePremiumPercentage?: number;
    maximumPremiumIncomeAmount?: number;
    generalTaxCreditDiscountAmountLowerLimit?: number;
    generalTaxCreditDiscountAmountUpperLimit?: number;
    employedGeneralTaxCreditDiscountpercentage?: number;
    employedGeneralTaxCreditMinimumDiscountAmount?: number;
    retiredGeneralTaxCreditDiscountpercentage?: number;
    retiredGeneralTaxCreditMinimumDiscountAmount?: number;
    elderlyDiscountAmountLowerLimit?: number;
    elderlyDiscountAmountUpperLimit?: number;
    elderlyDiscountPercentage?: number;
    maximumElderlyDiscountAmount?: number;
    singleElderlyDiscountAmount?: number;
    healthInsuranceUpperLimit?: number;
    healthInsuranceEmployedPercentage?: number;
    healthInsuranceRetiredPercentage?: number;
    healthInsuranceSelfEmployedPercentage?: number;
    employedDiscountTaxBracketAmount1?: number;
    employedDiscountTaxBracketAmount2?: number;
    employedDiscountTaxBracketAmount3?: number;
    employedDiscountTaxBracketAmount4?: number;
    employedDiscountTaxBracketPercentage1?: number;
    employedDiscountTaxBracketPercentage2?: number;
    employedDiscountTaxBracketPercentage3?: number;
    employedDiscountTaxBracketPercentage4?: number;
    retiredDiscountTaxBracketPercentage1?: number;
    retiredDiscountTaxBracketPercentage2?: number;
    retiredDiscountTaxBracketPercentage3?: number;
    retiredDiscountTaxBracketPercentage4?: number;
    singleAOWAmount?: number;
    livingTogetherAOWAmount?: number;
    maximumAOWAgeInMonths?: number;
    aowFranchise?: number;
    maximumPensionFoundation?: number;
    premiumPercentagePensionFoundation?: number;
    maximumYearSpace?: number;
    pensionGrowthFactor?: number;
    marketRate?: number;
    defaultRetirementPeriodInYears?: number;
    legalRetirementAge?: number;
    lateEarlyRetirement?: LateEarlyRetirement;
}

const getPensionCalcDataUrl = (year: number) => buildEndpoint(['pensioncalcdata', year.toString()]);

const getPensionCalcDataApiCall = (year: number) =>
    apifetch<PensionCalcData>(getPensionCalcDataUrl(year), 'GET');

export const useGetPensionCalcData = (year: number = DateTime.now().year) => {
    const query = useQuery<PensionCalcData>(['pensioncalcdata', year], async () => {
        return getPensionCalcDataApiCall(year)();
    },
    {
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    });

    return query;
};